import styled from '@emotion/styled';
import React from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { GNB_HEIGHT } from './GNB';

interface LayoutProps {
  hideFooter?: boolean;
  children: React.ReactNode;
}

const Layout = ({ hideFooter, children }: LayoutProps) => {
  return (
    <Container>
      <Header />
      {children}
      {!hideFooter && <Footer />}
    </Container>
  );
};

const Container = styled.main`
  position: relative;
  height: auto;
  overflow-x: clip;

  /* & > :nth-of-type(2) {
    padding-top: ${GNB_HEIGHT}px;
  } */
`;

export default Layout;
